module.exports = __webpack_public_path__ + "img/solana.487eeb8e.png";